/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Pit2_TInputs */

const en_to_yaml_pit2_t = /** @type {(inputs: To_Yaml_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML is a superset, so converting back is not automatic`)
};

const ko_to_yaml_pit2_t = /** @type {(inputs: To_Yaml_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML은 상위집합이므로 되돌리는 변환은 자동이 아닙니다`)
};

const ja_to_yaml_pit2_t = /** @type {(inputs: To_Yaml_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML は上位集合なので、戻す変換は自動ではありません`)
};

/**
* | output |
* | --- |
* | "YAML is a superset, so converting back is not automatic" |
*
* @param {To_Yaml_Pit2_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_pit2_t = /** @type {((inputs?: To_Yaml_Pit2_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Pit2_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_pit2_t(inputs)
	if (locale === "ko") return ko_to_yaml_pit2_t(inputs)
	return ja_to_yaml_pit2_t(inputs)
});